import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo3D from "@/components/hud/Logo3D";

// Handles Emergent Google OAuth redirect: #session_id=...
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/auth", { replace: true });
        return;
      }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const res = await api.post("/auth/google/session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data.user);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        navigate("/auth", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-app">
      <Logo3D size={120} />
      <div className="font-mono text-xs tracking-[0.3em] text-cyan/70 animate-pulse-glow">
        DECRYPTING IDENTITY...
      </div>
    </div>
  );
}
